import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CommodityViewComponent } from "./commodity-view/commodity-view.component";

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Commodity Master',
          },
        component: CommodityViewComponent,
    }
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CommodityRoutingModule {}